import { getDeviceInfo } from '@sitebase/device-detector';

const LAST_SITE_VISITED = 'lastSiteVisited';

export const isDesktop = getDeviceInfo().isDesktop;

export const getValueByDevice = ({ desktop, tablet, mobile }) => {
  switch (true) {
    case isDesktop:
      return desktop;
    case getDeviceInfo().isTablet:
      return tablet;
    case getDeviceInfo().isMobile:
    default:
      return mobile;
  }
};

export function getLastSiteVisited(fallback) {
  const lastSiteVisited = getCookie(LAST_SITE_VISITED);

  return lastSiteVisited || fallback;
}

export function getCookie(name) {
  return document.cookie
    .split(';')
    .map(function (cookie) {
      return cookie.trim();
    })
    .filter(function (cookie) {
      return cookie.substring(0, name.length) === name;
    })
    .map(function (cookie) {
      return cookie.split('=').pop();
    })
    .pop();
}

export function createOverlayNode() {
  let domNode = document.getElementById('cp-action-overlay');

  if (domNode === null) {
    domNode = document.createElement('div');
    domNode.id = 'cp-action-overlay';
    document.body.appendChild(domNode);
  }
}

export function disableBodyScroll() {
  document.body.classList.add('cp-body-no-scroll');
  document.documentElement.classList.add('cp-body-no-scroll');
}

export function enableBodyScroll() {
  document.body.classList.remove('cp-body-no-scroll');
  document.documentElement.classList.remove('cp-body-no-scroll');
}

export function setCookie(name, value, expires, domain) {
  document.cookie = `${name}=${value};expires=${expires};domain=.${domain}`;
}

export function getNuiCode(urlString) {
  if (typeof urlString !== 'string' || !urlString.includes('?')) {
    return '';
  }

  const queryString = urlString.substr(urlString.indexOf('nui'));
  const getNui = queryString.split('&').find((pair) => pair.split('=')[0] === 'nui');

  return getNui ? getNui.split('=').pop() : '';
}

export function redirectToLastVisitedSite(redirectURL) {
  window.location.href = getLastSiteVisited(redirectURL);
}

export function createCloseButton() {
  const closeButton = document.createElement('button');
  closeButton.setAttribute('type', 'button');
  closeButton.classList.add('cp-action-overlay__close-modal-button');
  closeButton.innerHTML = `
    <svg viewBox="0 0 32 32" style="width: 1em; height: 1em;" title="x icon" preserveAspectRatio="xMidYMid meet">
      <path d="M18 16L31.6 2.2a1 1 0 0 0 0-1.4l-.5-.5a1 1 0 0 0-1.4 0L16 14.1 2.2.3A1 1 0 0 0 .8.3L.3.8a1 1 0 0 0 0 1.4L14.1 16 .3 29.8a1 1 0 0 0 0 1.4l.5.5a1 1 0 0 0 1.4 0L16 17.9l13.8 13.8a1 1 0 0 0 1.4 0l.5-.5a1 1 0 0 0 0-1.4L17.9 16z"></path>
    </svg>`;
  return closeButton;
}
